<template>
  <article class="cmp cmp-product-thumb" :data-testing="item.variation.id">
    <div :class="paddingClasses" :style="paddingInlineStyles">
      <div v-if="isBasketCrosssellingEnabled" >
        <add-to-basket
            data-testing="item-add-to-basket"
            :variation-id="item.variation.id"
            :is-salable="!!item.filter && item.filter.isSalable"
            :has-children="!!item.item && item.item.salableVariationCount > 1"
            :interval-quantity="item.variation.intervalOrderQuantity || 1"
            :minimum-quantity="item.variation.minimumOrderQuantity"
            :maximum-quantity="!!item.variation.maximumOrderQuantity && item.variation.maximumOrderQuantity > 0 ? item.variation.maximumOrderQuantity : null"
            :order-properties="item.properties.filter(function(prop) { return prop.property.isOderProperty })"
            :has-order-properties="item.hasOrderProperties"
            :has-required-order-property="item.hasRequiredOrderProperty"
            :use-large-scale="false"
            :show-quantity="true"
            :item-url="item | itemURL(urlWithVariationId)"
            :has-price="item | hasItemDefaultPrice"
            :has-graduated-price="itemGraduatedPriceisCheapestSorting || itemGraduatedPricesalableVariationCount"
            :item-type="item.item.itemType">
        </add-to-basket>
      </div>

      <div class="reduced-procent" v-if="item.prices.rrp && item.prices.rrp.unitPrice.value > 0 && item.prices.rrp.unitPrice.value > item.prices.default.unitPrice.value" >

        <p>- {{ (1 - (item.prices.default.unitPrice.value / item.prices.rrp.unitPrice.value))*100 | numberFormat(0) }}%</p>

      </div>
      <div class="thumb-image">
        <div class="prop-1-1">
          <slot name="item-image">
            <template v-for="(images, key) in item.images" >
              <template v-for="(image, index) in images" v-if="key == 'all' && index <= 1">
                <template v-if="images.length > '1'">
                  <div v-if="index === 0" class="first-image">
                    <template v-if="paddingClasses && paddingClasses.includes('preloadItemListImage')">
                      <img class="img-fluid" :src="image.urlSecondPreview" :alt="item | itemName ">
                    </template>
                    <template v-else>
                      <lazy-img picture-class="img-fluid" :image-url="image.urlSecondPreview" :alt="item | itemName" ></lazy-img>
                    </template>
                  </div>
                  <div v-if="index === 1" class="hover-image-section">
                    <lazy-img
                        picture-class="img-fluid"
                        :image-url="image.urlSecondPreview"
                        :alt="item | itemName"
                    >
                    </lazy-img>
                    <div class="stars-section"></div>
                  </div>
                </template>
                <template v-else>
                  <template v-if="paddingClasses && paddingClasses.includes('preloadItemListImage')">
                    <img class="img-fluid" :src="image.urlSecondPreview" :alt="item | itemName">
                  </template>
                  <template v-else>
                    <lazy-img picture-class="img-fluid" :image-url="image.urlSecondPreview" :alt="item | itemName"></lazy-img>
                  </template>
                  <div class="hover-without-image-section">
                  </div>
                </template>
              </template>
            </template>
          </slot>
        </div>
      </div>

      <!-- STORE SPECIALS -->
      <slot name="store-special">
        <item-store-special v-if="storeSpecial || item.variation.bundleType === 'bundle' || item.item.itemType === 'set'"
                            :store-special="storeSpecial"
                            :recommended-retail-price="item.prices.rrp"
                            :variation-retail-price="item.prices.default"
                            :special-offer-price="item.prices.specialOffer"
                            :decimal-count="decimalCount"
                            :bundle-type="item.variation.bundleType"
                            :item-type="item.item.itemType">
        </item-store-special>
      </slot>
      <!-- ./STORE SPECIALS -->

      <!-- ITEM DETAILS -->
      <slot name="item-details">
        <div class="thumb-content">
          <a :href="item | itemURL(urlWithVariationId)" :aria-label="item | itemName" class="thumb-title small stretched-link">
            {{ item | itemName }} <span v-for="attribute in item.groupedAttributes">{{ "Ceres::Template.itemGroupedAttribute" | translate(attribute) }}</span>
          </a>
          <div class="thumb-meta mt-2">
            <slot name="before-prices"></slot>
            <div class="prices float-left">
              <div class="price">
                <template v-if="item.item.itemType === 'set'">
                  {{ $translate("Ceres::Template.itemSetPrice", { price: itemSetPrice }) }}
                </template>
                <template v-else-if="!!item.item && item.item.salableVariationCount > 1 && $ceres.isCheapestSorting" >
                  {{ $translate("Ceres::Template.itemFromPrice", { price: itemPrice }) }}
                </template>
                <template v-else>
                  {{ item.prices.default.unitPrice.formatted | specialOffer(item.prices, "unitPrice", "formatted") }}
                </template>
              </div>
              <div v-if="item.prices.rrp && item.prices.rrp.unitPrice.value > 0 && item.prices.rrp.unitPrice.value > item.prices.default.unitPrice.value" class="price-view-port">
                <del class="crossprice" v-if="item.prices.specialOffer">
                  {{ item.prices.default.unitPrice.formatted | itemCrossPrice(true) }}
                </del>
                <del class="crossprice" v-else>
                  {{ item.prices.rrp.unitPrice.formatted | itemCrossPrice }}
                </del>
              </div>
            </div>
            <template v-if="filteredProperties.length > 0">
              <div class="eek-img-section">
                <lazy-img
                    v-for="(property, index) in filteredProperties"
                    :key="index"
                    :image-url="getImageUrl(property.values.value)"
                    v-if="isValidValue(property.values.value)"
                />
              </div>
            </template>

          </div>
          <slot name="after-prices"></slot>
          <div class="category-unit-price small" v-if="!(item.unit.unitOfMeasurement === 'C62' && item.unit.content === 1)">
            <span>{{ item.unit.content }}</span>
            <span>&nbsp;{{ item.unit.names.name }}</span>
            <span v-if="item.variation.mayShowUnitPrice">&nbsp;| {{ item.prices.default.basePrice }}</span>
          </div>

          <div class="product-details-tab">
            <div class="shipping-information">
              {{item.variation.availability.names.name}}
            </div>
          </div>
        </div>
      </slot>
      <!-- ./ITEM DETAILS  -->
    </div>
  </article>
</template>

<script>
import { mapState } from "vuex";
import CategoryImageCarousel from "./CategoryImageCarousel.vue";
import ItemStoreSpecial from "./ItemStoreSpecial.vue";
import {getSlotData} from "../../helper/getSlotData";

export default {
    components: {
        CategoryImageCarousel,
        ItemStoreSpecial
    },

    props: {
        decimalCount:
        {
            type: Number,
            default: 0
        },
        imageUrlAccessor:
        {
            type: String,
            default: "urlMiddle"
        },
        itemData:
        {
            type: Object
        },
        disableCarouselOnMobile:
        {
            type: Boolean
        },
        paddingClasses:
        {
            type: String,
            default: null
        },
        paddingInlineStyles:
        {
            type: String,
            default: null
        },
        forceUrlWithVariationId:
        {
            type: Boolean,
            default: false
        },
        showBasketCrossselling:
        {
          type: Boolean,
          default: true
        }
    },

    jsonDataFields: [
        "itemDataRef"
    ],

    computed:
    {
        item()
        {
            return this.itemData || this.itemSlotData || this.itemDataRef;
        },

        itemSlotData: getSlotData('item-data'),

        /**
         * returns itemData.item.storeSpecial
         */
        storeSpecial()
        {
            return this.item.item.storeSpecial;
        },

        /**
         * returns itemData.texts
         */
        texts()
        {
            return this.item.texts;
        },

        itemPrice()
        {
            return this.$options.filters.specialOffer(this.item.prices.default.unitPrice.formatted, this.item.prices, "unitPrice", "formatted" );
        },

        basePrice()
        {
            return this.item.prices.default.basePrice;
        },

        itemPriceGraduated()
        {
           let unitPrice;
           if (App.config.item.enableGraduatedPrices) {
             unitPrice = this.item.prices.graduatedPrices.length > 0
                 ? this.item.prices.graduatedPrices[0].unitPrice
                 : this.item.prices.default.unitPrice;
           } else {
             unitPrice = this.item.prices.default.unitPrice;
           }

            return this.$options.filters.specialOffer(unitPrice.formatted, this.item.prices, "unitPrice", "formatted" );
        },

        itemGraduatedPriceisCheapestSorting()
        {
            return !!this.item.item && this.item.item.salableVariationCount > 1 && !!this.$ceres.isCheapestSorting;
        },

        itemGraduatedPricesalableVariationCount()
        {
            return !!this.item.item && this.item.item.salableVariationCount == 1 && this.item.prices.graduatedPrices.length > 1 && App.config.item.enableGraduatedPrices;
        },

        itemSetPrice()
        {
            return this.$options.filters.currency(
                this.item.prices.default.price.value,
                this.item.prices.default.currency
            );
        },

        urlWithVariationId()
        {
            return !this.$ceres.config.item.showPleaseSelect || this.$ceres.initialPleaseSelect == 0 || this.forceUrlWithVariationId;
        },

        hasCrossPrice() {
            const hasRrpPrice = !!this.item.prices.rrp &&
                this.item.prices.rrp.unitPrice.value > this.item.prices.default.unitPrice.value;

            const hasBeforePrice = !!this.item.prices.specialOffer &&
                !!this.item.prices.default &&
                this.item.prices.default.unitPrice.value > this.item.prices.specialOffer.unitPrice.value;

            return hasRrpPrice || hasBeforePrice;
        },

        ...mapState({
            showNetPrices: state => state.basket.showNetPrices
        }),
      // Prüft, ob die Struktur keine propertyGroups enthält
      hasFlatProperties() {
        return this.item.variationProperties && !this.item.variationProperties.some(group => group.properties);
      },
      isBasketCrosssellingEnabled() {
        return this.showBasketCrossselling === true || this.showBasketCrossselling === 'true';
      },
      // Filtere die relevanten Properties basierend auf der Struktur
      filteredProperties() {
        if (!this.item.variationProperties) {
          return [];
        }

        const properties = this.item.variationProperties;

        // Prüfen, ob propertyGroups vorhanden sind
        const hasGroups = properties.some(group => group.properties);

        if (hasGroups) {
          // Wenn propertyGroups vorhanden sind, iteriere über group.properties
          return properties
              .flatMap(group => group.properties)
              .filter(property => property.id === 172);
        } else {
          // Wenn keine propertyGroups vorhanden sind, arbeite direkt mit properties
          return properties.filter(property => property.property.id === 172);
        }
      }
    },
  methods: {
    // Prüft, ob der Wert gültig ist (A-G)
    isValidValue(value) {
      const validValues = ['A', 'B', 'C', 'D', 'E', 'F', 'G'];
      return validValues.includes(value);
    },
    // Gibt die Bild-URL basierend auf dem Wert zurück
    getImageUrl(value) {
      const baseUrl = 'https://cdn02.plentymarkets.com/9krpwzxa6mmo/frontend/shop_res/items/eek/';
      return `${baseUrl}${value.toLowerCase()}-links.svg`;
    },
  }
}
</script>
